import Lenis from 'lenis';
import WithSizes from '../classes/WithSizes';
import { Sizes } from '../types';
import { gsap } from 'gsap';

import { ScrollTrigger } from 'gsap/ScrollTrigger';
import SmoothScroll from '../singleton/SmoothScroll';

gsap.registerPlugin(ScrollTrigger);

class Header extends WithSizes {
  $header: JQuery<HTMLElement>;
  $body: JQuery<HTMLElement>;
  $hamburger: JQuery<HTMLElement>;
  $nav: JQuery<HTMLElement>;
  $headerClose: JQuery<HTMLElement>;
  // $logo: JQuery<HTMLElement>;
  $heroMenuBtn: JQuery<HTMLElement>;

  headerIsOpened: boolean;
  isScrollingDisabled: boolean;
  isDark: boolean;
  isHome: boolean;
  threshold: number;
  smoothScroll: typeof SmoothScroll;

  constructor(
    sizes: Sizes,
  ) {
    super(sizes);
    this.$header = $('.header');
    this.$nav = $('.nav');
    this.$body = $('body');
    this.$hamburger = this.$header.find('.header__hamburger');
    this.$heroMenuBtn = $('.hero__menu');
    this.$headerClose = this.$nav.find('.nav__close');

    this.headerIsOpened = false;
    this.isScrollingDisabled = false;
    this.isDark = false;
    this.isHome = this.$body.hasClass('home');
    this.threshold = 100;

    this.smoothScroll = SmoothScroll;

    this.init();
  }

  init() {
    this.$hamburger.on('click', this.onHamburgerClick.bind(this));
    this.$heroMenuBtn.on('click', this.onHamburgerClick.bind(this));
    this.$headerClose.on('click', this.closeNav.bind(this));
    this.smoothScroll.scroll.on('scroll', this.onScroll.bind(this));
  }

  onHamburgerClick() {
    if (!this.headerIsOpened) {
      this.openNav();
    } else {
      this.closeNav();
    }
  }

  openNav() {
    this.smoothScroll.disableScrolling();
    this.$nav.attr('aria-expanded', 'true');
    this.$hamburger.attr('aria-expanded', 'true');
    this.$header.addClass('is-opened');

    this.headerIsOpened = true;
    this.isScrollingDisabled = true;
  }

  closeNav() {
    this.$nav.attr('aria-expanded', 'false');
    this.$hamburger.attr('aria-expanded', 'false');
    this.$header.removeClass('is-opened');

    if (this.isScrollingDisabled) {
      this.smoothScroll.enableScrolling();
      this.isScrollingDisabled = false;
    }

    this.headerIsOpened = false;
  }

  onResize(sizes: Sizes) {
    super.onResize(sizes);

    if (this.headerIsOpened) {
      this.closeNav();
    }
  }

  onScroll(e: Lenis) {
    const st = e.scroll;

    if(e.isStopped) return;

    if (e.direction === -1) {
      this.$header.addClass('is-scrolling-up');
    } else {
      this.$header.removeClass('is-scrolling-up');
    }

    if (st > this.threshold) {
      this.$header.addClass('is-scrolling');
    } else {
      this.$header.removeClass('is-scrolling');
    }
  }
}

export default Header;
